import React, { useState, useEffect } from "react";
import { supabase } from "../supabaseClient";
import { useAuth } from "../AuthContext";

const ProfilePage = () => {
  const { user } = useAuth();
  const [email, setEmail] = useState("");
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [error, setError] = useState(null);
  const [message, setMessage] = useState(null);

  useEffect(() => {
    if (user) {
      setEmail(user.email);
      fetchProfile();
    }
  }, [user]);

  const fetchProfile = async () => {
    try {
      const response = await fetch(
        `${process.env.REACT_APP_API_URL}/profile/${user.id}`
      );
      if (!response.ok) throw new Error("Failed to fetch profile");
      const data = await response.json();
      setFirstName(data.firstName);
      setLastName(data.lastName);
    } catch (error) {
      setError("Kon profiel niet ophalen");
      console.error("Error fetching profile:", error);
    }
  };

  const handleUpdateProfile = async (e) => {
    e.preventDefault();
    try {
      const response = await fetch(
        `${process.env.REACT_APP_API_URL}/profile/${user.id}`,
        {
          method: "PUT",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({ firstName, lastName }),
        }
      );
      if (!response.ok) throw new Error("Failed to update profile");
      const data = await response.json();
      setMessage("Profiel succesvol bijgewerkt");
    } catch (error) {
      setError("Kon profiel niet bijwerken");
      console.error("Error updating profile:", error);
    }
  };

  const handleChangePassword = async (e) => {
    e.preventDefault();
    const { error } = await supabase.auth.updateUser({ password: newPassword });
    if (error) {
      setError(error.message);
    } else {
      setMessage("Wachtwoord succesvol gewijzigd");
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50">
      <div className="max-w-md w-full bg-white p-8 rounded-lg shadow-md">
        <h2 className="text-2xl font-bold mb-6">Profiel</h2>
        {error && <div className="text-red-500 mb-4">{error}</div>}
        {message && <div className="text-green-500 mb-4">{message}</div>}
        <form onSubmit={handleUpdateProfile}>
          <div className="mb-4">
            <label className="block text-gray-700">E-mail</label>
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="w-full px-4 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-nn-500"
              required
              disabled
            />
          </div>
          <div className="mb-4">
            <label className="block text-gray-700">Voornaam</label>
            <input
              type="text"
              value={firstName}
              onChange={(e) => setFirstName(e.target.value)}
              className="w-full px-4 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-nn-500"
              required
            />
          </div>
          <div className="mb-4">
            <label className="block text-gray-700">Achternaam</label>
            <input
              type="text"
              value={lastName}
              onChange={(e) => setLastName(e.target.value)}
              className="w-full px-4 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-nn-500"
              required
            />
          </div>
          <button
            type="submit"
            className="w-full px-4 py-2 bg-nn-500 text-white rounded-lg hover:bg-nn-600"
          >
            Profiel bijwerken
          </button>
        </form>
        <form onSubmit={handleChangePassword} className="mt-6">
          <div className="mb-4">
            <label className="block text-gray-700">Nieuw wachtwoord</label>
            <input
              type="password"
              value={newPassword}
              onChange={(e) => setNewPassword(e.target.value)}
              className="w-full px-4 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-nn-500"
              required
            />
          </div>
          <button
            type="submit"
            className="w-full px-4 py-2 bg-nn-500 text-white rounded-lg hover:bg-nn-600"
          >
            Wachtwoord wijzigen
          </button>
        </form>
      </div>
    </div>
  );
};

export default ProfilePage;
